const config = {
    basename: '/manager',
    defaultPath: '/home/dashboard/default',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    theme: 'dark',
    i18n: 'vi', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
};

export default config;
